import { render, staticRenderFns } from "./import.vue?vue&type=template&id=2a4517d9&lang=pug&"
import script from "./import.vue?vue&type=script&lang=js&"
export * from "./import.vue?vue&type=script&lang=js&"
import style0 from "./import.vue?vue&type=style&index=0&id=2a4517d9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports